<template>
  <div
    :class="{
      'container mt-6': true,
    }"
  >
    <h2>
      {{ title }}
    </h2>
    <p
      :class="{
        'mb-4 text-center text-xs leading-7 text-www-color-neutral-medium-dark md:text-15px': true,
      }"
    >
      {{ subtitle }}
    </p>
    <div
      :class="{
        relative: true,
      }"
    >
      <UssPersonaObject
        v-for="(card, index) in personaList"
        :key="index"
        v-bind="card"
        :is-selected="selectedPersonaTitle === card.personaTitle"
        :is-highlighted="
          highlightedPersona === card.personaTitle ||
          (!highlightedPersona && selectedPersonaTitle === card.personaTitle) ||
          (!highlightedPersona && !selectedPersonaTitle && index === 0)
        "
        @select="onSelectPersona"
        @hover="highlightedPersona = $event.personaTitle"
        @hover-end="highlightedPersona = ''"
      />
    </div>
    <slot />
    <template v-if="screenPartialData?.sectionBuilder?.length > 0">
      <component
        :is="getComponent(component._type)"
        v-for="component in screenPartialData?.sectionBuilder"
        :key="component._key"
        :value="component"
      />
    </template>
  </div>
</template>

<script lang="ts" setup>
import { FieldHtmlNameUtil } from '@onshape/www-inertia';
import UssPersonaObject from '~/components/Atmos/SignUpPartials/ussPersona/UssPersonaObject.vue';
import type { SignupPartialViewsSectionBuilder, UssPersona } from '~/sanity/types';
import type UnifiedSignupSessionInfo from '~/hekate-www/external/facets/Form/coordinator/UnifiedSignup/session-info/UnifiedSignupSessionInfo';
import type { SignupScreen } from '~/hekate-www/external/facets/Form/coordinator/UnifiedSignup/screens/SignupScreen';
import { getComponent } from '~/components/Mapper';

const { signupScreen } = defineProps<
  UssPersona & {
    signupScreen: SignupScreen;
    sessionInfo: UnifiedSignupSessionInfo;
    screenPartialData: SignupPartialViewsSectionBuilder;
  }
>();

const experienceField = signupScreen.getField(FieldHtmlNameUtil.whatIsYourExperience);
const personaDetailField = signupScreen.getField(FieldHtmlNameUtil.personaDetail);

const selectedPersonaTitle = ref<string>('');
const highlightedPersona = ref<string>('');

const onSelectPersona = (args: {
  persona: string;
  personaDetails: string;
  personaTitle: string;
}) => {
  selectedPersonaTitle.value = args.personaTitle;
  experienceField.val = args.persona;
  personaDetailField.val = args.personaDetails;
};
</script>

<style></style>
